import script from "./BalancesGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalancesGraph.vue?vue&type=script&setup=true&lang=ts"

import "./BalancesGraph.vue?vue&type=style&index=0&id=262113de&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-262113de"]])

export default __exports__